import { render } from "./TransferForm.vue?vue&type=template&id=58bb7cbb&scoped=true"
import script from "./TransferForm.vue?vue&type=script&lang=js"
export * from "./TransferForm.vue?vue&type=script&lang=js"

import "./TransferForm.vue?vue&type=style&index=0&id=58bb7cbb&scoped=true&lang=css"
import "./TransferForm.vue?vue&type=style&index=1&id=58bb7cbb&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bb7cbb"]])

export default __exports__